import { render, staticRenderFns } from "./DetailOptionsButton.vue?vue&type=template&id=18747b96&"
import script from "./DetailOptionsButton.vue?vue&type=script&lang=ts&"
export * from "./DetailOptionsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports